import React, { useState } from 'react';

import Grid from '@material-ui/core/Grid'

import LinkIcon from '@material-ui/icons/Link';
import { LinearProgress, List, ListItem, ListItemText, Button, Snackbar } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Alert } from '@material-ui/lab';
import Typography from '@material-ui/core/Typography'

import { all } from '../../../app/data/validate';
import AlphabetChooser from '../../organizations/AlphabetChooser';
import { createOrganizationLink, defaultAccountNumber, removeOrganizationLink } from './XeroContactApi';
import MuiSwitch from '../../../app/common/ui/MuiSwitch';
import { Spaced } from '../../../app/common/ui/Spacer';
import XeroContactList from './XeroContactList';

const OrganizationList = ({ organizations, organization, onSelect, contacts }) => {
    const [selectedOrganization, setSelectedOrganization] = useState(organization);

    const handleClick = org => {
        // if (org.xeroContactId) return;

        const updated = org === selectedOrganization ? undefined : org;
        setSelectedOrganization(updated);
        onSelect(updated);
    }

    return (
        <List>
            {
                organizations.filter(({ name }) => Boolean(name)).sort((a, b) => a.name?.localeCompare(b.name)).map(org => {
                    const contact = contacts.find(c => c.AccountNumber === defaultAccountNumber(org));
                    const link = contact ? `Linked to ${contact.Name}` : org.phoneNumber;

                    return (
                        <ListItem key={org.id} onClick={() => handleClick(org)} selected={selectedOrganization?.id === org.id} >
                            <ListItemIcon>
                                <LinkIcon color={org.xeroContactId ? "secondary" : "primary"} />
                            </ListItemIcon>
                            <ListItemText primary={org.name} secondary={link} />
                        </ListItem>
                    );
                })
            }
        </List>
    );
}

const XeroLinkOrganizationContent = ({ organizations, contacts, onUpdate, db }) => {
    const [regex, setRegex] = useState();
    const [filterLetter, setFilterLetter] = useState();
    const [selectedOrganization, setSelectedOrganization] = useState();
    const [selectedtContact, setSelectedContact] = useState();
    const [success, setSuccess] = useState(false);
    const [busy, setBusy] = useState(false);
    const [showLinked, setShowLinked] = useState(false);

    const handleContactSelect = contact => {
        setSelectedContact(contact);
    }

    const handleOrganizationSelect = organization => {
        setSelectedOrganization(organization);
        if (organization?.xeroContactId && !selectedtContact) {
            setSelectedContact(contacts.find(c => c.AccountNumber === defaultAccountNumber(organization)));
        }
    }

    const handleCreateLinkClick = () => {
        if (all(selectedOrganization, selectedtContact)) {
            setBusy(true);
            createOrganizationLink({
                db,
                organization: selectedOrganization,
                contact: selectedtContact,
            })
                .then(digest => {
                    setBusy(false);
                    setSuccess(true);
                    setSelectedContact(undefined);
                    setSelectedOrganization(undefined);
                    onUpdate(digest);
                })
                .catch(error => {
                    setBusy(false);
                    console.log(error)
                });
        }
    }

    const handleUnlinkClick = () => {
        setBusy(true);
        removeOrganizationLink({
            db,
            organization: selectedOrganization,
            contact: selectedtContact,
        })
            .then(digest => {
                setBusy(false);
                setSuccess(true);
                setSelectedContact(undefined);
                setSelectedOrganization(undefined);
                onUpdate(digest);
            })
            .catch(error => {
                setBusy(false);
                console.log(error)
            });
    }

    const handleClose = (_, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSuccess(false);
    };

    const handleLetterChange = letter => {
        // toggle letter / name filter
        if (letter !== filterLetter) {
            setFilterLetter(letter);
            setRegex(new RegExp(`^${letter}`, 'i'))
        }
        else {
            setFilterLetter(undefined);
            setRegex(undefined);
        }
    }

    return (
        <React.Fragment>
            <Grid container spacing={1}>
                <Grid item>
                    <Typography variant="h6" color="textSecondary" style={{ marginLeft: '1rem', marginBottom: '1rem' }}>Link TiCiT Referrers to XERO Contacts</Typography>
                </Grid>
                <Grid item style={{ marginLeft: 'auto' }}>
                    <MuiSwitch value={false} label="Show Linked" colour="secondary" onChange={() => setShowLinked(!showLinked)} />
                </Grid>
            </Grid>
            <Grid container direction="column" spacing={2}>
                <Grid item style={{ marginLeft: '1rem' }}>
                    <AlphabetChooser onClick={handleLetterChange} />
                </Grid>
                <Grid item style={{ marginLeft: '1rem' }}>
                    {all(selectedtContact, selectedOrganization) && (!selectedtContact?.AccountNumber && !selectedOrganization?.xeroContactId) && !busy &&
                        <Button onClick={handleCreateLinkClick} variant="contained" color="primary" style={{ marginBottom: '1rem' }} startIcon={<LinkIcon />} >LINK {selectedOrganization.name} IN TICIT to {selectedtContact.Name} IN XERO</Button>}

                    {all(selectedtContact, selectedOrganization) && (selectedtContact?.AccountNumber && selectedOrganization?.xeroContactId) && !busy &&
                        <Button onClick={handleUnlinkClick} variant="contained" color="secondary" style={{ marginBottom: '1rem' }} startIcon={<LinkIcon />} >UNLINK {selectedOrganization.name} IN TICIT FROM {selectedtContact.Name} IN XERO</Button>}

                    {busy && <Spaced><LinearProgress /></Spaced>}
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item lg={6}>
                    <Typography variant="h6" color="initial" style={{ marginLeft: '1rem' }}>Ticit Referrers</Typography>
                    <OrganizationList
                        onSelect={handleOrganizationSelect}
                        organization={selectedOrganization}
                        organizations={organizations.filter(o => !regex || regex.test(o.name))
                            .filter(o => showLinked || !Boolean(o.xeroContactId))}
                        contacts={contacts} />
                </Grid>
                <Grid item lg={6}>
                    <Typography variant="h6" color="initial" style={{ marginLeft: '1rem' }}>Xero Contacts</Typography>
                    <XeroContactList
                        onSelect={handleContactSelect}
                        contact={selectedtContact}
                        counterparts={organizations}
                        contacts={contacts.filter(c => !regex || regex.test(c.Name))
                            .filter(c => showLinked || !Boolean(c.AccountNumber))} />
                </Grid>
            </Grid>
            <Snackbar open={success} autoHideDuration={5000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert variant="filled" severity="success">XERO Contact Links Updated</Alert>
            </Snackbar>
        </React.Fragment>
    );
};

export default XeroLinkOrganizationContent;